import { render, staticRenderFns } from "./AddressEditorDialog.vue?vue&type=template&id=77d67840&"
import script from "./AddressEditorDialog.vue?vue&type=script&lang=js&"
export * from "./AddressEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports